// // import React from "react";
// import { Link, useNavigate } from "react-router-dom";
// import React, { useState, useEffect } from "react";


// const Header = () => {
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     // auth data clear (if any)
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");

//     // redirect to index / home
//     navigate("/");
//   };
// const [userName, setUserName] = useState("User");

// useEffect(() => {
//   const user = JSON.parse(localStorage.getItem("user"));
//   if (user?.name) {
//     setUserName(user.name);
//   }
// }, []);
//   return (
//     <div className="dashboard_header">

//       {/* ROW 1 – SEARCH + USER */}
//       <div className="header_top">

//         {/* LEFT */}
//         <div className="header_left">
//           <h4 className="welcome_text">
//             Welcome, <span>{userName}</span>!
//           </h4>

//           <div className="search_wrapper">
//             <input
//               className="search_bar"
//               placeholder="Search for ingredients or products..."
//             />
//             <button className="search_btn">
//               <i className="fas fa-search"></i>
//             </button>
//           </div>
//         </div>

//         {/* RIGHT */}
//         <div className="header_right">

//           {/* NOTIFICATION */}
//           <Link to="/notifications" className="icon_box">
//             <i className="fas fa-bell"></i>
//             <span className="badge">3</span>
//           </Link>

//           {/* CART */}
//           <Link to="/cart" className="icon_box">
//             <i className="fas fa-shopping-cart"></i>
//             <span className="badge">5</span>
//           </Link>

//           {/* LOGOUT */}
//           <div
//             className="icon_box logout_icon"
//             title="Logout"
//             onClick={handleLogout}
//             style={{ cursor: "pointer" }}
//           >
//             <i className="fas fa-sign-out-alt"></i>
//           </div>

//         </div>
//       </div>

//     </div>
//   );
// };

// export default Header;



import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { dashboardSearchMap } from "../../utils/dashboardSearchMap";
import { resolveIdentity } from "../../utils/identity";
import { useTranslation } from "react-i18next";
import { APP_URLS } from "../../config/routes";
const API = "https://api.mahal.qa/api/v1/orders";

const Header = ({ onProfileClick }) => {

  const navigate = useNavigate();
  const identity = resolveIdentity();

  const role =
    identity?.role || localStorage.getItem("role");

  const linkedId =
    identity?.linkedId || localStorage.getItem("linked_id");

  const [userName, setUserName] = useState("User");

  const [query, setQuery] = useState("");
  const [notificationCount, setNotificationCount] = useState(0);

  const [allProducts, setAllProducts] = useState([]);
  const totalNotifications = notificationCount;
  const { t, i18n } = useTranslation();


  const fetchCount = async () => {
    const token = localStorage.getItem("token");
    const identity = resolveIdentity();

    if (!token || identity?.role?.toUpperCase() !== "SUPPLIER") return;


    try {
      const res = await fetch(
        "https://api.mahal.qa/api/v1/orders/supplier/notifications/count",
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = await res.json();
      console.log("🔔 COUNT API:", data);
      setNotificationCount(Number(data.count) || 0);
    } catch (e) {
      console.error("Count fetch failed", e);
      setNotificationCount(0);
    }
  };


  useEffect(() => {
    const handler = () => fetchCount();
    window.addEventListener("refreshNotifications", handler);
    return () =>
      window.removeEventListener("refreshNotifications", handler);
  }, []);
  useEffect(() => {
    if (!identity || !role) return;

    fetchCount();
    const interval = setInterval(fetchCount, 20000);
    return () => clearInterval(interval);
  }, [identity, role]);

  useEffect(() => {
    const fetchProducts = async () => {

      const supplierId =
        resolveIdentity()?.linkedId ||
        localStorage.getItem("linked_id");

      const token = localStorage.getItem("token");

      if (!supplierId || !token) {
        return;
      }

      try {

        const res = await fetch(
          `https://api.mahal.qa/api/products?supplier_id=${supplierId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await res.json();

        setAllProducts(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Failed to fetch products:", err);
        setAllProducts([]);
      }
    };

    fetchProducts();
  }, []);


  const decrementNotificationCount = () => {
    setNotificationCount((c) => Math.max(0, c - 1));
  };

  useEffect(() => {
    const loadUser = () => {
      const storedUsername = localStorage.getItem("username");

      if (storedUsername) {
        setUserName(storedUsername.split("@")[0]);
        return;
      }

      const token = localStorage.getItem("token");

      if (!token) return;

      try {
        const decoded = jwtDecode(token);

        if (decoded.username) {
          setUserName(decoded.username.split("@")[0]);
        }
      } catch (err) {
        console.error(err);
      }
    };

    loadUser();

    window.addEventListener("storage", loadUser);

    return () => {
      window.removeEventListener("storage", loadUser);
    };
  }, []);


  useEffect(() => {
    const handleOpenProfile = () => {
      if (onProfileClick) {
        onProfileClick();
      }
    };

    window.addEventListener("openProfile", handleOpenProfile);

    return () => {
      window.removeEventListener("openProfile", handleOpenProfile);
    };
  }, [onProfileClick]);

  // const handleLogout = () => {
  //   localStorage.clear();
  //   navigate("/");
  // };
  // const handleLogout = () => {
  //   localStorage.clear();
  //   sessionStorage.clear();

  //   navigate("/supplierlogin", { replace: true });
  // };


  const handleLogout = async () => {
  const token = localStorage.getItem("token");

  try {
    if (token) {
      await fetch("https://api.mahal.qa/api/auth/logout", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
  } catch (err) {
    console.error("Logout failed:", err);
  }

  localStorage.clear();
  sessionStorage.clear();

  navigate("/supplierlogin", { replace: true });
};


  const goToProfile = () => {
    if (!role) return;

    // admin → no linkedId
    if (role === "admin") {
      navigate(`/admin/profile/admin/0`);
    } else {
      navigate(`/admin/profile/${role}/${linkedId}`);
    }
  };

  // const handleSearch = () => {
  //   const text = query.toLowerCase().trim();
  //   if (!text) return;

  //   const match = dashboardSearchMap.find((item) =>
  //     item.keywords.some((k) => text.includes(k))
  //   );

  //   if (match) {
  //     navigate(match.route);
  //     setQuery("");
  //   } else {
  //     alert("No matching section found");
  //   }
  // };




  const handleSearch = async () => {
    const text = query.toLowerCase().trim();

    if (!text) return;

    // 🔥 DASHBOARD SEARCH FROM DB
    const dashboardRes = await fetch(
      `https://api.mahal.qa/api/dashboard/search?q=${text}`
    );

    const dashboardData = await dashboardRes.json();

    if (dashboardData.length > 0) {
      navigate(dashboardData[0].route);
      setQuery("");
      return;
    }

    // 🔥 PRODUCT SEARCH
    const productMatch = allProducts.find((p) =>
      (p.name || p.product_name_english || "")
        .toLowerCase()
        .includes(text)
    );

    if (productMatch) {
      navigate(`/product/${productMatch.id}`);
      setQuery("");
      return;
    }

    // 🔥 NORMAL SEARCH
    navigate(`/restaurantdashboard/${text}`);
  };

  return (
    <div className="dashboard_header">
      <div className="header_top">
        <div className="header_left">
          <h4 className="welcome_text">
            {t("welcome")}, <span>{userName}</span>!
          </h4>
          <div className="search_wrapper">
            <input
              className="search_bar"
              placeholder={t("search_placeholder")}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            />
            <button className="search_btn" onClick={handleSearch}>
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>

        <div className="header_right">


          {/* LANGUAGE */}
          <div className="lang_wrapper">

            <i className="fa-solid fa-globe lang_icon"></i>

            <span className="lang_text">
              {i18n.language === "ar" ? "العربية" : "EN"}
            </span>

            <i className="fa-solid fa-chevron-down lang_arrow"></i>

            <select
              className="lang_dropdown"
              value={i18n.language}
              onChange={(e) => {
                const lang = e.target.value;
                i18n.changeLanguage(lang);
                document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
                localStorage.setItem("i18nextLng", lang);
              }}
            >
              <option value="en">EN</option>
              <option value="ar">العربية</option>
            </select>

          </div>

          {/* <div
            className="icon_box logout_icon"
            style={{ cursor: "pointer" }}
            // onClick={goToProfile}
            onClick={onProfileClick}
            title={t("profile")}
          >
            <i className="fas fa-user-circle"></i>
          </div> */}

          <a
            href={`${APP_URLS.SUPPLIER}/profile/${localStorage.getItem("role")}/${localStorage.getItem("linked_id")}`}
            className="icon_box"
          >
            <i className="fas fa-user"></i>
          </a>

          <a
            href={`${APP_URLS.SUPPLIER}/dashboard/notifications`}
            className="icon_box notification_icon"
          >
            <i className="fas fa-bell"></i>

            {totalNotifications > 0 && (
              <span className="notification_badge">
                {totalNotifications > 9 ? "9+" : totalNotifications}
              </span>
            )}
          </a>




          <div
            className="icon_box logout_icon"
            onClick={handleLogout}
            style={{ cursor: "pointer" }}
          >
            <i className="fas fa-sign-out-alt"></i>
          </div>


        </div>
      </div>
    </div>
  );
};

export default Header;
